import { render, staticRenderFns } from "./menuUserManageList.vue?vue&type=template&id=3ed81648&scoped=true"
import script from "./menuUserManageList.vue?vue&type=script&lang=js"
export * from "./menuUserManageList.vue?vue&type=script&lang=js"
import style0 from "./menuUserManageList.vue?vue&type=style&index=0&id=3ed81648&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed81648",
  null
  
)

export default component.exports